import './App.css';
import Inicio from './Components/Inicio/Inicio';
import Navbar from './Components/Navbar/Navbar';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Inicio/>
    </div>
  );
}

export default App;
